"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackUserEvent = exports.setupHeapUser = exports.identifyCio = exports.heapIdentify = exports.forgetUser = exports.cioIdentify = exports.SIGNUP_PAGE_REFERRAL_QUERY_PARAM_NAME = exports.SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME = exports.SIGNUP_PAGE_EMAIL_QUERY_PARAM_NAME = void 0;
var _utils = require("../../utils");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME = 'SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME';
exports.SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME = SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME;
var SIGNUP_PAGE_REFERRAL_QUERY_PARAM_NAME = 'referral';
exports.SIGNUP_PAGE_REFERRAL_QUERY_PARAM_NAME = SIGNUP_PAGE_REFERRAL_QUERY_PARAM_NAME;
var SIGNUP_PAGE_EMAIL_QUERY_PARAM_NAME = 'email';
exports.SIGNUP_PAGE_EMAIL_QUERY_PARAM_NAME = SIGNUP_PAGE_EMAIL_QUERY_PARAM_NAME;
var formatDateForAnalytics = function formatDateForAnalytics(date) {
  return _momentTimezone.default.utc(date).format('MMM DD YYYY h:mm A z');
};
var getPlanName = function getPlanName(program) {
  return (0, _utils.isFreemium)(program.planId) ? _utils.FREEMIUM_PLAN_ID : program === null || program === void 0 ? void 0 : program.name;
};
var toHeapDataFormat = function toHeapDataFormat(data) {
  var formatted = (0, _lodash.reduce)(data, function (result, value, key) {
    result[(0, _lodash.upperFirst)(key)] = (0, _lodash.toString)(value);
    return result;
  }, {});
  return formatted;
};
var toCioDataFormat = function toCioDataFormat(data) {
  var formatted = (0, _lodash.mapKeys)(data, function (val, key) {
    return (0, _lodash.snakeCase)(key);
  });
  return formatted;
};
var heapIdentify = function heapIdentify(email, identity) {
  if (!window.heap) {
    return;
  }
  window.heap.addUserProperties(toHeapDataFormat(identity));
};
exports.heapIdentify = heapIdentify;
var cioIdentify = function cioIdentify(email, identity) {
  if (!window._cio) {
    return;
  }
  identity.id = email.toLowerCase();
  if (identity.email) {
    identity.email = email.toLowerCase();
  }
  window._cio.identify(toCioDataFormat(identity));
};
exports.cioIdentify = cioIdentify;
var setupHeapUser = function setupHeapUser(_ref, roleName) {
  var firstName = _ref.firstName,
    email = _ref.email,
    planType = _ref.planType,
    firstCallCompleted = _ref.firstCallCompleted,
    paidSignupDate = _ref.paidSignupDate,
    score = _ref.score,
    landingPage = _ref.landingPage,
    state = _ref.state;
  if (!window.heap) {
    return;
  }
  var props = {};
  if (firstName) {
    props.Name = firstName;
  }
  if (email) {
    var sanitizedEmail = email.toLowerCase();
    props.Email = sanitizedEmail;
    props.email = sanitizedEmail;
  }
  if (roleName) {
    props.Role = roleName;
  }
  if (planType) {
    props.PlanType = planType;
  }
  if (firstCallCompleted) {
    props.FirstCallCompleted = firstCallCompleted;
  }
  if (paidSignupDate) {
    props.PaidSignupDate = paidSignupDate;
  }
  if (score) {
    props.DSM5Score = score;
  }
  if (landingPage) {
    props.LandingPage = landingPage;
  }
  if (state) {
    props.state = state;
  }
  if (!(0, _lodash.isEmpty)(props)) {
    window.heap.addUserProperties(props);
  }
};
exports.setupHeapUser = setupHeapUser;
var trackUserEvent = function trackUserEvent(_ref2) {
  var eventName = _ref2.eventName,
    eventValues = _ref2.eventValues;
  if (window.heap && window._cio) {
    if (eventValues) {
      window.heap.track(eventName, eventValues);
      window._cio.track(eventName, eventValues);
    } else {
      window.heap.track(eventName);
      window._cio.track(eventName);
    }
  }
};
exports.trackUserEvent = trackUserEvent;
var identifyCio = function identifyCio(_ref3) {
  var email = _ref3.email,
    createdAt = _ref3.createdAt,
    firstName = _ref3.firstName,
    preferredName = _ref3.preferredName,
    roleName = _ref3.roleName,
    planType = _ref3.planType,
    firstCallCompleted = _ref3.firstCallCompleted,
    score = _ref3.score,
    landingPage = _ref3.landingPage;
  if (!window._cio) {
    return;
  }
  var props = {};
  if (email) {
    props.id = email.toLowerCase();
    props.email = email.toLowerCase();
  }
  if (createdAt) {
    props.created_at = Date.parse(createdAt) / 1000;
  }
  if (firstName) {
    props.first_name = preferredName || firstName;
  }
  if (roleName) {
    props.role = roleName;
  }
  if (planType) {
    props.plan_type = planType;
  }
  if (firstCallCompleted) {
    props.first_call_completed = firstCallCompleted;
  }
  if (score) {
    props.dsm5_score = score;
  }
  if (landingPage) {
    props.landing_page = landingPage;
  }
  if (!(0, _lodash.isEmpty)(props)) {
    window._cio.identify(props);
  }
};
exports.identifyCio = identifyCio;
var forgetUser = function forgetUser() {
  if (window.heap) {
    window.heap.resetIdentity();
  }
};
exports.forgetUser = forgetUser;